import {useIntl} from 'react-intl'

export const Stepper = ({activeStep}: {activeStep: number}) => {
  const intl = useIntl()

  const steps = [
    {
      id: 1,
      title: intl.formatMessage({id: 'BECOME_MERCHANT.STEP_1'}),
      description: intl.formatMessage({id: 'BECOME_MERCHANT.STEP_1_DESCRIPTION'}),
    },
    {
      id: 2,
      title: intl.formatMessage({id: 'BECOME_MERCHANT.STEP_2'}),
      description: intl.formatMessage({id: 'BECOME_MERCHANT.STEP_2_DESCRIPTION'}),
    },
    {
      id: 3,
      title: intl.formatMessage({id: 'BECOME_MERCHANT.STEP_3'}),
      description: intl.formatMessage({id: 'BECOME_MERCHANT.STEP_3_DESCRIPTION'}),
    },
  ]

  return (
    <div>
      <div className='stepper stepper-pills' id='kt_stepper_example_basic'>
        <div className='stepper-nav flex-center mb-0'>
          {steps.map((step, index) => (
            <div
              className={`stepper-item mx-8 my-4 ${activeStep === step.id ? 'current' : ''}`}
              data-kt-stepper-element='nav'
              key={index}
            >
              <div className='stepper-wrapper d-flex align-items-center'>
                <div className='stepper-icon w-40px h-40px'>
                  <i className='stepper-check fas fa-check'></i>
                  <span className='stepper-number'>{step.id}</span>
                </div>

                <div className='stepper-label'>
                  <h3 className='stepper-title'>{step.title}</h3>

                  <div className='stepper-desc d-none d-lg-block'>{step.description}</div>
                </div>
              </div>

              <div className='stepper-line h-40px'></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
